import fire from '../../firebase/config';

export const get_order_for_signature = fire.functions().httpsCallable('get_order_for_signature');
export const save_signature_to_order = fire.functions().httpsCallable('save_signature_to_order');